const vocabularyActionTypes =  {    
    RETRIEVED_VOCABULARY_LIST: "RETRIEVED_VOCABULARY_LIST",
    UPDATED_VOCABULARY: "UPDATED_VOCABULARY",
    ADDED_VOCABULARY: "ADDED_VOCABULARY",
    DELETED_VOCABULARY: "DELETED_VOCABULARY",
    FAILED_TO_ADD_VOCABULARY: "FAILED_TO_ADD_VOCABULARY"
};
export default vocabularyActionTypes;
